// extracted by mini-css-extract-plugin
export default {"wrapper":"_HJFGwVcrvNyK7JnePwj","formWrapper":"b7TV5GkhiyDDRwYASuMR","quotaAttainment":"V7_4lDfl9hLFHwUyCeQs","resourceObjectSample":"dimEinYZamFj7doBLCLX"};